import React, { useEffect, useMemo } from 'react';

import MDPProductList from './mdp-product';
import TabsContainer from '../../shared/components/tabs-container'
import TabSelectBar from '../../shared/components/tab-select-bar'
import Tabs from '../../shared/components/tabs'
import Tab from '../../shared/components/tab'
import {Helpers} from '../../core/src/helpers'
import HeroBanner from './hero-banner';

import './mdp.less';

export const getTabs = (featuresTabHtml, productsList) => {
    // There are much better ways and algorithms to do this sorting,
    // this is only for illustrating the purpose of useMemo.
    let tabs = [];

    if (featuresTabHtml && featuresTabHtml.html) {
        tabs.push({
            name: 'Features',
            component: () => <div dangerouslySetInnerHTML={Helpers.createMarkup(featuresTabHtml.html)}></div>,
            trackName: 'prodDetailsTab',
        });
    }
    if (productsList && productsList.length > 0) {
        tabs.push({
            name: 'Buy',
            component: () => <MDPProductList products={productsList} />,
            trackName: 'prodDetailsTab',
        });
    }
    return tabs;
}

const MDP = ({ featuresTabHtml, productsList }) => {
    return <div className={'mdp'}>
            <HeroBanner />
            <div dangerouslySetInnerHTML={Helpers.createMarkup(featuresTabHtml && featuresTabHtml.html)}></div>
            <MDPProductList products={productsList} />
    </div>;
}

export default MDP;